var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _rect, _circle6, _circle7, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 110,
    viewBox: "0 0 124 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.2922,
    cy: 54.5339,
    r: 51.4875,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2987 42.3872L123.591 56.0158L118.555 109.641L60.7812 95.1239L75.2987 42.3872Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.296 55.7191L72.6334 42.6831C70.1644 46.2384 63.8044 55.4229 58.116 63.7185C52.4275 72.0142 42.5122 82.1863 38.2656 86.2353L97.5204 103.715C98.6067 103.123 103.209 98.7973 112.927 86.2353C122.644 73.6733 123.889 60.657 123.296 55.7191Z",
    fill: "#F3F3F3",
    stroke: "#CCCCCC",
    strokeWidth: 0.592547
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.0733,
    cy: 56.608,
    r: 2.37019,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9639,
    cy: 69.0518,
    r: 2.37019,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.8546,
    cy: 80.3101,
    r: 2.37019,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4416,
    cy: 29.6997,
    r: 21.6214,
    transform: "rotate(25.8347 29.4416 29.6997)",
    fill: "#F0F0F0",
    stroke: "#D2D2D2",
    strokeWidth: 0.592547
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.8509,
    height: 1.77764,
    transform: "matrix(1 0 0 -1 22.6328 35.9214)",
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0012,
    cy: 26.1443,
    r: 3.25901,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.1106,
    cy: 26.1443,
    r: 3.25901,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0234,
    y: 71.0967,
    width: 28.4423,
    height: 1.18509,
    rx: 0.592547,
    transform: "rotate(15.5 76.0234 71.0967)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8203,
    y: 83.105,
    width: 25.7443,
    height: 1.18509,
    rx: 0.592547,
    transform: "rotate(15.5 69.8203 83.105)",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 83.8359,
    y: 58.4126,
    width: 28.4423,
    height: 1.18509,
    rx: 0.592547,
    transform: "rotate(14.5 83.8359 58.4126)",
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.633c4853df5b2c4b3a61c793c342bb6b.svg";
export { ForwardRef as ReactComponent };